// import Vue from 'vue'
import {
    RUN_USER_LOGIN,
    RUN_USER_SIGNUP,
    RUN_VERIFY_LEAD_OTP,
    RUN_USER_LOGOUT,
    SET_TOGGLE_LOADER,
    SET_INFO,
    SET_STATE,
    SET_STATE_PERSIST_LOCAL,
    RUN_DELETE_DOC,
    RUN_SAVE_USER_NAME,
    RUN_REGISTER_STEP1,
    RUN_REGISTER_STEP2,
    RUN_REGISTER_STEP3,
    RUN_REGISTER_STEP4,
    RUN_REGISTER_STEP5,
    RUN_SKIP_DOCUMENT_UPLOAD,
    GET_TOKEN,
    RUN_GET_QUESTION_ANSWER,
    RUN_STATE_LOAD,
    RUN_USER_FORGOT_PASSWORD,
    RUN_GET_USER_IP,
    RUN_GENERATE_2FA_QRCODE,
    RUN_VERIFY_2FA_QRCODE,
    RUN_DISABLE_2FA_QRCODE,
    RUN_USER_RESET_PASSWORD_FROM_HASH,
    RUN_CHANGE_PASSWORD,
    RUN_GET_SUM_SUB_RESPONSE,
    RUN_RESOLVE_DOC_ISSUE,
    RUN_USER_LOGIN_2FA,
    SAVE_FIREBASE_TOKEN,
    RUN_FINANCIAL_DETAILS,
} from "../types";
import * as RxFactory from "./api/rx-factory";
import * as Enpoints from "./api/endpoints";
import * as COMMON from "./commomFunction";
import * as types from "@/types";
import { Const } from "../plugins/fxView/provider/candle-history/lib/const.cls";
import eventHandler from "../plugins/buttonHandler";

export const actions = {
    //================================get country code===============================
    [RUN_GET_USER_IP]({ commit, state, getters }, credentials) {
        RxFactory.get("https://api.ipify.org/?format=json")
            .map((response) => response.data)
            .subscribe(
                (data) => {
                    /*RxFactory.get("https://ipapi.co/" + data.ip + "/json?key=WqrqGPQYxfU6ySEZKqlU8bNDk9BgWVez4Uk3L4auzRyosaOWSs")*/
                    RxFactory.get("https://expapi.fxview.com/get/geo")
                        .map((response) => response.data)
                        .subscribe(
                            (data) => {
                                if (credentials.globalParams.verify) {
                                    // credentials.localParams.parameter.userCountry = data.country_code
                                    credentials.localParams.parameter.userCountry = data;
                                    credentials.localParams.parameter.runVerify();
                                } else {
                                    // credentials.localParams.parameter.userCountry = data.country_code
                                    credentials.localParams.parameter.userCountry = data;
                                }
                            },
                            (e, d, s) => {}
                        );
                },
                (e, d, s) => {}
            );
    },
    //================================2FA===========================================
    [RUN_GENERATE_2FA_QRCODE]({ commit, state, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_GENERATE_2FA_QRCODE, credentials, "", commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.src_data = result.res_data;
            } else {
                if (credentials.localParams.parameter.call_from != "" || credentials.localParams.parameter.call_from != null) {
                    credentials.localParams.parameter.$parent.authComponent = true;
                }
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [RUN_VERIFY_2FA_QRCODE]({ commit, state, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_VERIFY_2FA_QRCODE, credentials, "", commit, (error, result) => {
            if (!error) {
                let user_json = getters["GET_USER"];
                user_json.profile.gAuthenticatorEnabled = 1;
                commit(SET_STATE, user_json);
                localStorage.setItem("unauthFlag", "");
                var user = localStorage.getItem("user");
                user = atob(user);
                user = JSON.parse(user);
                user.profile.gAuthenticatorEnabled = 1;
                localStorage.setItem("user", btoa(JSON.stringify(user)));
                credentials.localParams.parameter.div_show = "";
                if (credentials.localParams.parameter.call_from != "" || credentials.localParams.parameter.call_from != null) {
                    credentials.localParams.parameter.$parent.authComponent = false;
                } else {
                    credentials.localParams.parameter.otp = "";
                    credentials.localParams.parameter.div_show = "";
                }
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz1", "success");
            } else {
                //credentials.localParams.parameter.div_show = ''
                if (credentials.localParams.parameter.call_from != "" || credentials.localParams.parameter.call_from != null) {
                    credentials.localParams.parameter.$parent.authComponent = true;
                }
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [RUN_DISABLE_2FA_QRCODE]({ commit, state, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_DISABLE_2FA_QRCODE, credentials, "", commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.DisableOtp = "";
                credentials.localParams.parameter.div_show = "";
                credentials.localParams.parameter.generateQrCode();
                let user_json = getters["GET_USER"];
                user_json.profile.gAuthenticatorEnabled = 0;
                commit(SET_STATE, user_json);

                var user = localStorage.getItem("user");
                user = atob(user);
                user = JSON.parse(user);
                user.profile.gAuthenticatorEnabled = 0;
                localStorage.setItem("user", btoa(JSON.stringify(user)));
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz2", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [SAVE_FIREBASE_TOKEN]({ commit, state, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_SAVE_FIREBASE_TOKEN, credentials, "", commit, (error, result) => {
            if (!error) {
                //console.log('firebase_token--',result.res_data)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //================================login==========================================
    [RUN_USER_LOGIN]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_USER_LOGIN, credentials, "", commit, (error, result) => {
            if (!error) {
                localStorage.setItem("unauthFlag", "");
                if (parseInt(result.res_data.user.profile.gAuthenticatorEnabled) == 1) {
                    credentials.localParams.parameter.gAuthenticatorEnabled = true;
                } else {

                    result.res_data.user.loggedIn = true;
                    commit(SET_STATE, result.res_data.user);
                    localStorage.setItem("user", btoa(JSON.stringify(result.res_data.user)));
                    // let getpath = localStorage.getItem("lastPath");
                    // let getQuery = localStorage.getItem("query");
                    //console.log(localStorage.getItem("lastPath"),getpath) live user id 86645 // dev id 73766

                    if ((parseInt(result.res_data.user.profile.user_id) < 86645) && parseInt(result.res_data.user.step) <= 4 && parseInt(result.res_data.user.verified_status) != 2 && result.res_data.user.first_deposit != 1)  {
                        credentials.localParams.parameter.$router.replace("/choose-account");
                    } 
                    // else if ((parseInt(result.res_data.user.profile.user_id) < 73766) && )
                    else if (parseInt(result.res_data.user.verified_status) == 2 || result.res_data.user.first_deposit == 1) {
                        credentials.localParams.parameter.$router.replace("/dashboard");
                    } else if ((parseInt(result.res_data.user.step) == 0) && (parseInt(result.res_data.user.profile.account.length) == 0 )) {
                        console.log(result.res_data.user.profile.account.length, "TAGGGGG 2")
                        credentials.localParams.parameter.$router.replace("/choose-account");
                    }  
                    else if(parseInt(result.res_data.user.profile.account.length > 0) && parseInt(result.res_data.user.step) == 0) {
                        credentials.localParams.parameter.$router.replace("/dashboard");
                    } 
                    else if (parseInt(result.res_data.user.step) >= 1  && (parseInt(result.res_data.user.profile.account.length) == 0 ))  {
                        if (parseInt(result.res_data.user.step) == 4) {
                            console.log('STEP 4')
                            credentials.localParams.parameter.$router.replace("/step3");
                        } else {
                            let lastStep = "/step" + (parseInt(result.res_data.user.step) + 1);
                            credentials.localParams.parameter.$router.replace(lastStep);
                        }
                    } 
                    else {
                        console.log("9", parseInt(result.res_data.user.step));
                        // Check each account for demo_live = 1
                        let demoAccounts = result.res_data.user.profile.account.filter(acc => parseInt(acc.demo_live) == 0);
                        let liveAccounts = result.res_data.user.profile.account.filter(acc => parseInt(acc.demo_live) == 1);
    
                        if(demoAccounts.length > 0 && (parseInt(result.res_data.user.step) == 0 || parseInt(result.res_data.user.step) == 1 ) && !liveAccounts.length) {
                            console.log("11")
                            let lastStep = "/step" + (parseInt(result.res_data.user.step) + 1);
                            credentials.localParams.parameter.$router.replace(lastStep);
                            // credentials.localParams.parameter.$router.replace("/dashboard");
                        } else if (parseInt(result.res_data.user.step) === 2 && (demoAccounts.length > 0 && !liveAccounts.length > 0)) {
                            credentials.localParams.parameter.$router.replace("/step3");
                        } else if (parseInt(result.res_data.user.step) === 2 && (!demoAccounts.length || liveAccounts.length > 0)) {
                            sessionStorage.setItem('account_detail', JSON.stringify(liveAccounts[0]))
                            credentials.localParams.parameter.$router.replace("/step3");
                        }   else if (parseInt(result.res_data.user.step) === 4 && (demoAccounts.length > 0 || liveAccounts.length > 0) && !result.res_data.user.profile.documents) {
                            console.log('Documents Step', result.res_data.user.profile.documents)
                            credentials.localParams.parameter.$router.replace("/step5");
                        }   else{
                            console.log('Documents', result.res_data.user.profile.documents)
                            credentials.localParams.parameter.$router.replace("/dashboard");
                        }
                    }
                    // if (getpath != undefined) {
                    //     if (getQuery && getQuery != undefined) {
                    //         credentials.localParams.parameter.$router.replace({ path: getpath, query: { ticketData: getQuery } });
                    //     } else {
                    //         credentials.localParams.parameter.$router.replace(getpath);
                    //     }
                    // } else {
                    //     console.log('UserLoggedIn==========TAG2')
                    //     if (parseInt(result.res_data.user.verified_status) == 2) {
                    //         console.log('UserLoggedIn==========TAG3')
                    //         credentials.localParams.parameter.$router.replace("/dashboard");
                    //     } else if (parseInt(result.res_data.user.step) == 0) {
                    //         console.log('UserLoggedIn==========TAG4')
                    //         credentials.localParams.parameter.$router.replace("/choose-account");
                    //     } else if (parseInt(result.res_data.user.step) >= 1) {
                    //         let lastStep = "/step" + (parseInt(result.res_data.user.step) + 1);
                    //         credentials.localParams.parameter.$router.replace(lastStep);
                    //     } else if(parseInt(result.res_data.user.profile.account.length > 0)) {
                    //         console.log("dataaaaaa", result.res_data.user.profile.account.length)
                    //         credentials.localParams.parameter.$router.replace("/dashboard");
                    //     } else {
                    //         console.log('UserLoggedIn==========TAG5')
                    //         credentials.localParams.parameter.$router.replace("/dashboard");
                    //     }
                    // }
                }
            } else {
                console.log('UserLoggedIn==========TAG6')
                // COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_msg, "error");
            }
        });
    },
    [RUN_USER_LOGIN_2FA]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_USER_LOGIN_2FA, credentials, "", commit, (error, result) => {
            if (!error) {
                localStorage.setItem("unauthFlag", "");
                result.res_data.user.loggedIn = true;
                commit(SET_STATE, result.res_data.user);
                localStorage.setItem("user", btoa(JSON.stringify(result.res_data.user)));
                let getpath = localStorage.getItem("lastPath");
                let getQuery = localStorage.getItem("query");

                window.gtag("config", "G-STJT5YW0S4", {
                    user_id: "GL_" + result.res_data.user.profile.user_id,
                });

                //console.log(localStorage.getItem("lastPath"),getpath)
                if (getpath != undefined) {
                    if (getQuery && getQuery != undefined) {
                        credentials.localParams.parameter.$router.replace({ path: getpath, query: { ticketData: getQuery } });
                    } else {
                        credentials.localParams.parameter.$router.replace(getpath);
                    }
                } else {
                    const id = result.res_data.user.profile.user_id;
                    console.log(id, "without 2fa")
                    eventHandler(id);
                    if (parseInt(result.res_data.user.verified_status) == 2) {
                        credentials.localParams.parameter.$router.replace("/dashboard");
                    } else if (parseInt(result.res_data.user.step) < 4) {
                        // credentials.localParams.parameter.$router.replace('/dashboard')
                        let lastStep = "/step" + (parseInt(result.res_data.user.step) + 1);
                        credentials.localParams.parameter.$router.replace(lastStep);
                    } else {
                        credentials.localParams.parameter.$router.replace("/dashboard");
                    }
                }
            } else {
                // COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_msg, "error");
            }
        });
    },
    //===========================Reset-password-from-hash=====================================
    [RUN_USER_RESET_PASSWORD_FROM_HASH]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_RESET_PASSWORD_FROM_HASH, credentials, "", commit, (error, result) => {
            if (!error) {
                const _that = credentials.localParams.parameter;

                _that.displayMessage = 1;
                _that.displayMessageText = "Password has been changed successfully. Kindly click here tp login";
                //  COMMON._messageDisplayFunction(credentials.localParams.parameter,'','success')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "errorMsz1", "error");
            }
        });
    },
    //===========================forgot-password=====================================
    [RUN_USER_FORGOT_PASSWORD]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_USER_FORGOT_PASSWORD, credentials, "", commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.resend = true;
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz3", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [RUN_CHANGE_PASSWORD]({ commit, state, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_CHANGE_PASSWORD, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.clear();
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz4", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //================================signup=========================================
    [RUN_USER_SIGNUP]({ commit, state, dispatch, getters }, credentials) {
        return new Promise((resolve,reject) => {
            COMMON._executeApi(Enpoints.EP_USER_SIGNUP, credentials, "", commit, (error, result) => {
                if (!error) {
                    result.res_data.user.loggedIn = true;
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, "SignUp successfully", "success");
                    commit(SET_STATE, result.res_data.user);
                    localStorage.setItem("user", btoa(JSON.stringify(result.res_data.user)));
                    console.log('Lead_Verfied=====================');
                    credentials.localParams.parameter.$router.replace("/choose-account");
                    resolve(result)
                    // COMMON._messageDisplayFunction(credentials.localParams.parameter, "OTP resend successfully", "success");
                } else {
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_msg, "error");
                    reject(error)
                }
            });
        })
    },
    // [RUN_USER_SIGNUP]({ commit, state, dispatch, getters }, credentials) {
    //     COMMON._executeApi(Enpoints.EP_USER_SIGNUP, credentials, "", commit, (error, result) => {
    //         if (!error) {
    //             if (credentials.localParams.page) {
    //                 // credentials.localParams.parameter.insertId = result.res_data.insertId;
    //                 COMMON._messageDisplayFunction(credentials.localParams.parameter, "OTP resend successfully", "success");
    //                 // COMMON._messageDisplayFunction(credentials.localParams.parameter,'suceessMsz5','success')
    //             } else {
    //                 window.gtag("event", "G_Gen_lead", { event_name: "G_Gen_lead" /*, 'send_to': 'G-1E20EEPN1W'*/ });
    //                 window.fbq("trackCustom", "generate_lead", { value: "0", country: credentials.globalParams.residence_country, Currency: "USD" }, { eventID: credentials.globalParams.email });
    //                 // window.fbq('track', 'initiate checkout');
    //                 credentials.localParams.parameter.otpPageEvent()
    //                 // credentials.localParams.parameter.insertId = result.res_data.insertId;
    //                 // COMMON._messageDisplayFunction(credentials.localParams.parameter,'OTP is sent on your register email and mobile number','success')
    //                 // COMMON._messageDisplayFunction(credentials.localParams.parameter,'suceessMsz6','success')
    //             }
    //         } else {
    //             // COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
    //             COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_msg, "error");
    //         }
    //     });
    // },
    // [RUN_VERIFY_LEAD_OTP]({ commit, state, dispatch, getters }, credentials) {
    //     COMMON._executeApi(Enpoints.EP_VERIFY_LEAD_OTP, credentials, "", commit, (error, result) => {
    //         if (!error) {
    //             credentials.localParams.parameter.otpSubmitEvent();
    //             COMMON._messageDisplayFunction(credentials.localParams.parameter, "SignUp successfully", "success");
    //             result.res_data.user.loggedIn = true;
    //             commit(SET_STATE, result.res_data.user);
    //             console.log('Lead_Verfied=====================');
    //             credentials.localParams.parameter.$router.replace("/choose-account");
    //             try {
    //                 // console.log(result.res_data.user.profile.country, "==================userrrrrrrrrrrr")
    //                 // window.gtag('event', 'conversion', { 'send_to': 'AW-10955500403/9w0bCK3p5OEDEPPW_uco' });
    //                 window.gtag("config", "G-STJT5YW0S4", {
    //                     user_id: "GL_" + result.res_data.user.profile.user_id,
    //                 });
    //                 // window.rdt('track', 'SignUp')
    //                 // window.twq('event', 'tw-och2p-octc6', {});

    //                 window.gtag("event", "OTP_verified", { event_name: "OTP_verified", user_id: "GL_" + result.res_data.user.profile.user_id});
                    

    //                 window.gtag('event', 'conversion', {'send_to': 'AW-757510680/lesNCPTWpPoYEJjkmukC'});

    //                 window.fbq(
    //                     "trackCustom",
    //                     "OTP_verified",
    //                     { OTP: credentials.globalParams.OTP, value: "20", country: result.res_data.user.profile.country, Currency: "USD" },
    //                     { eventID: credentials.globalParams.OTP + "-" + result.res_data.user.profile.user_id }
    //                 );

    //                 window.teads_e.push({ conversionType: "CompleteRegistration" });

    //                 // window.gtag('event', 'G_OTP_verified', {'event_name': 'G_OTP_verified', 'send_to': 'G-1E20EEPN1W', 'user_id': "GL_"+result.res_data.user.profile.user_id });
    //                 // window.fbq('track', 'lead', {'external_id': "GL_"+result.res_data.user.profile.user_id});

    //                 let p_countries = {
    //                     AE: 104607,
    //                     AR: 104608,
    //                     AU: 103314,
    //                     BR: 104609,
    //                     CA: 104610,
    //                     DE: 103065,
    //                     DK: 103066,
    //                     ES: 103313,
    //                     IT: 104611,
    //                     KE: 104612,
    //                     MA: 104613,
    //                     NG: 104614,
    //                     NL: 103061,
    //                     PE: 104615,
    //                     PL: 104616,
    //                     PT: 103312,
    //                     SA: 104617,
    //                     SE: 103309,
    //                     ZA: 104618,
    //                 };
    //                 /*fetch('https://ipapi.co/country?key=WqrqGPQYxfU6ySEZKqlU8bNDk9BgWVez4Uk3L4auzRyosaOWSs').then(res => {*/
    //                 /*fetch('https://expapi.fxview.com/get/geo').then(res => {
    //                     if (res.ok) { 
    //                         return res.text(); 
    //                     }
    //                     else { 
    //                         throw new Error('HTTP Error ' + res.status); 
    //                     }
    //                 })
    //                 .then(country => {*/
    //                 let country = localStorage.getItem("ip_country") || "";
    //                 if (p_countries[country]) {
    //                     var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
    //                     var crypto = require("crypto");
    //                     try {
    //                         /*let email = crypto.createHash('md5').update(this.get_user.email).digest("hex");*/
    //                         let email = crypto.createHash("md5").update("1").digest("hex");
    //                         let setAccount = { event: "setAccount", account: p_countries[country] };
    //                         let setEmail = { event: "setEmail", email: email, hash_method: "md5" };
    //                         let setSiteType = { event: "setSiteType", type: deviceType };
    //                         let trackTransaction = { event: "trackTransaction", id: result.res_data.user.profile.user_id, item: [{ id: "registration", price: "1", quantity: "1" }] };
    //                         /*console.log('critio-update-Conversion-before :- ',JSON.stringify([setAccount,setEmail,setSiteType,trackTransaction]))*/
    //                         window.criteo_q.push(setAccount, setEmail, setSiteType, trackTransaction);
    //                         /*console.log('critio-update-Conversion-after :- ',JSON.stringify([setAccount,setEmail,setSiteType,trackTransaction]))*/
    //                     } catch (e) {
    //                         console.log(e);
    //                     }
    //                 }
    //                 /*}).catch(function(error) { console.log(error);  });*/
    //             } catch (e) {
    //                 console.log("Signup error", e);
    //                 //do nothing event not trackiung
    //             }
    //             localStorage.setItem("user", btoa(JSON.stringify(result.res_data.user)));
    //             credentials.localParams.parameter.flashSuccess("register successfully", { timeout: 10000 });
    //             // credentials.localParams.parameter.$router.replace('/step1')
    //             //rshaikh asking==
    //             // let getpath = localStorage.getItem("lastPath");
    //             // let getQuery = localStorage.getItem("query");
    //             // if (getpath) {
    //             //     if (getQuery && getQuery != undefined) {
    //             //         credentials.localParams.parameter.$router.replace({ path: getpath, query: { ticketData: getQuery } });
    //             //     } else {
    //             //         credentials.localParams.parameter.$router.replace(getpath);
    //             //     }
    //             // } else {
    //             //     alert("choose-account")
    //             //     credentials.localParams.parameter.$router.replace("/choose-account");
    //             // }
    //         } else {
    //             // COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
    //             if (result.res_msg == "OTP verification error") {
    //                 let msg = "Incorrect OTP entered. Please check your email for the correct OTP";
    //                 COMMON._messageDisplayFunction(credentials.localParams.parameter, msg, "error");
    //             } else {
    //                 COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_msg, "error");
    //             }
    //         }
    //     });
    // },
    [RUN_STATE_LOAD]({ commit, state, dispatch, getters }, credentials) {
        const data = {};
        let user = localStorage.getItem("user");
        if (user) {
            user = atob(user);
            user = JSON.parse(user);
        }
        if (user == null || user == "" || location.pathname == "/") {
            localStorage.setItem("unauthFlag", "");
        }
        if ((user == null || user == "" || location.pathname !== "/forgot/password/" || location.pathname !== "/forgot-password") && location.pathname == "/Users/dashboard") {
            localStorage.setItem("unauthFlag", true);
        } else {
            commit(SET_STATE, user);
            if (user !== null && user !== "") {
                localStorage.setItem("unauthFlag", "");
                COMMON._executeApi("/get/fresh/user/data", credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
                    if (!error) {
                        result.res_data.user.loggedIn = true;
                        commit(SET_STATE, result.res_data.user);
                        localStorage.setItem("user", btoa(JSON.stringify(result.res_data.user)));

                        result.res_data.user.loggedIn = true;
                        commit(SET_STATE, result.res_data.user);
                        localStorage.setItem("user", btoa(JSON.stringify(result.res_data.user)));
                        if (credentials.localParams.page) {
                            credentials.localParams.parameter.pageLoader = false;
                        }
                        if (credentials.localParams.page && credentials.localParams.page == "individual_doc_step") {
                            credentials.localParams.parameter.tierFunc();
                        } else if (credentials.localParams.page && credentials.localParams.page != "individual_doc_step") {
                            credentials.localParams.parameter.$router.replace("/dashboard");
                        }
                    } else {
                        COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
                    }
                });
            }
        }
    },
    //================================logout========================================
    [RUN_USER_LOGOUT]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_ADMIN_LOGOUT, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                COMMON._handleLogout(result.data, commit, { router: credentials.localParams.parameter.$router, forward: true });
                localStorage.removeItem("lastPath");
                localStorage.removeItem("query");
                sessionStorage.removeItem("account_detail");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //================================register Financial ============================
    [RUN_FINANCIAL_DETAILS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_FINANCIAL_DETAILS, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.financialDetails = result.res_data;
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    
    //================================register steps=================================
    [RUN_REGISTER_STEP1]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_REGISTER_STEP1, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                //credentials.localParams.parameter.$parent.$parent.showStepComponent = true
                let user_json = getters["GET_USER"];
                user_json.step = 1;
                user_json.username = credentials.globalParams.fname + " " + credentials.globalParams.mname + " " + credentials.globalParams.lname;
                user_json.profile.firstname = credentials.globalParams.fname;
                user_json.profile.middlename = credentials.globalParams.mname;
                user_json.profile.lastname = credentials.globalParams.lname;
                commit(SET_STATE, user_json);

                var user = localStorage.getItem("user");
                user = atob(user);
                user = JSON.parse(user);
                user.step = 1;
                localStorage.setItem("user", btoa(JSON.stringify(user)));
                credentials.localParams.parameter.$router.push("/step2");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [RUN_REGISTER_STEP2]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_REGISTER_STEP2, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                let user_json = getters["GET_USER"];
                user_json.step = 2;
                commit(SET_STATE, user_json);

                var user = localStorage.getItem("user");
                user = atob(user);
                user = JSON.parse(user);
                user.step = 2;
                localStorage.setItem("user", btoa(JSON.stringify(user)));
                credentials.localParams.parameter.$router.push("/step3");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    // [RUN_REGISTER_STEP3]({ commit, state, dispatch, getters }, credentials) {
    //     COMMON._executeApi(Enpoints.EP_REGISTER_STEP3, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
    //         if (!error) {
    //             let user_json = getters["GET_USER"];
    //             var user = localStorage.getItem("user");
    //             user = atob(user);
    //             user = JSON.parse(user);
    //             user_json.step = 3;
    //             user.step = 3;
    //             commit(SET_STATE, user_json);
    //             localStorage.setItem("user", btoa(JSON.stringify(user)));
    //             credentials.localParams.parameter.$router.push("/step4");
    //             console.log(user_json, "===========user_json 3")
    //         } else {
    //             COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
    //         }
    //     });
    // },
    // [RUN_REGISTER_STEP4]({ commit, state, dispatch, getters }, credentials) {
    //     COMMON._executeApi(Enpoints.EP_REGISTER_STEP4, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
    //         if (!error) {
    //             let user_json = getters["GET_USER"];
    //             user_json.step = 4;
    //             commit(SET_STATE, user_json);

    //             var user = localStorage.getItem("user");
    //             user = atob(user);
    //             user = JSON.parse(user);
    //             user.step = 4;
    //             localStorage.setItem("user", btoa(JSON.stringify(user)));
    //             credentials.localParams.parameter.$router.push("/step5");
    //             console.log(user_json, "===========user_json 4")
    //         } else {
    //             COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
    //         }
    //     });
    // },
    // [RUN_REGISTER_STEP3]({ commit, state, dispatch, getters }, credentials) {
    //     COMMON._executeApi(Enpoints.EP_REGISTER_STEP3, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
    //         if (!error) {
    //             let user_json = getters["GET_USER"];
    //             user_json.profile.total_points = result.res_data.total_points;
    //             var user = localStorage.getItem("user");
    //             user = atob(user);
    //             user = JSON.parse(user);
    //             user.profile.total_points = result.res_data.total_points;
    //             if (parseInt(result.res_data.total_points) < 3) {
    //                 commit(SET_STATE, user_json);
    //                 localStorage.setItem("user", btoa(JSON.stringify(user)));
    //                 credentials.localParams.parameter.test_failed = true;
    //                 localStorage.setItem("user", btoa(JSON.stringify(user)));
    //                 credentials.localParams.parameter.test_failed = 1;
    //                 localStorage.setItem("user", btoa(JSON.stringify(user)));
    //             } else if (parseInt(result.res_data.total_points) > 2 && parseInt(result.res_data.total_points) < 10) {
    //                 commit(SET_STATE, user_json);
    //                 localStorage.setItem("user", btoa(JSON.stringify(user)));
    //                 localStorage.setItem("user", btoa(JSON.stringify(user)));
    //                 credentials.localParams.parameter.test_failed = 2;
    //                 credentials.localParams.parameter.show_warning = true;
    //             } else {
    //                 user_json.step = 3;
    //                 user.step = 3;
    //                 commit(SET_STATE, user_json);
    //                 localStorage.setItem("user", btoa(JSON.stringify(user)));
    //                 credentials.localParams.parameter.$router.push("/step4");
    //             }
    //         } else {
    //             COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
    //         }
    //     });
    // },
    // [RUN_REGISTER_STEP4]({ commit, state, dispatch, getters }, credentials) {
    //     COMMON._executeApi(Enpoints.EP_REGISTER_STEP4, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
    //         if (!error) {
    //             let user_json = getters["GET_USER"];
    //             user_json.step = 4;
    //             commit(SET_STATE, user_json);

    //             var user = localStorage.getItem("user");
    //             user = atob(user);
    //             user = JSON.parse(user);
    //             user.step = 4;
    //             localStorage.setItem("user", btoa(JSON.stringify(user)));
    //             credentials.localParams.parameter.$router.push("/step5");
    //         } else {
    //             COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
    //         }
    //     });
    // },
    [RUN_REGISTER_STEP5]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_REGISTER_STEP5, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                window.gtag("event", "Verified_live_Account", { event_name: "Verified_live_Account"});
                if (credentials.localParams.step != undefined) {
                    let user_json = getters["GET_USER"];
                    user_json.step = 5;
                    commit(SET_STATE, user_json);

                    var user = localStorage.getItem("user");
                    user = atob(user);
                    user = JSON.parse(user);
                    user.step = 5;
                    localStorage.setItem("user", btoa(JSON.stringify(user)));

                    credentials.localParams.parameter.$parent.ticket_id = result.res_data[0].insertId;
                    credentials.localParams.parameter.clientKycEvent()
                    localStorage.setItem("ticketId", result.res_data[0].insertId);
                    // credentials.localParams.parameter.$router.replace('/dashboard')

                    // if (!(credentials.localParams.parameter.mobileScreen)) {
                    credentials.localParams.parameter.$router.replace({ name: "fxView.view", query: { id: result.res_data[0].insertId } });
                    // }
                } else {
                    credentials.localParams.parameter.documentJsonData = {};
                    credentials.localParams.parameter.stepInfo();
                    // credentials.localParams.parameter.clearOld();
                    credentials.localParams.parameter.showTab += 1;
                    credentials.localParams.parameter.faliNameChange();
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //========================================================================================================================================================
    [RUN_SAVE_USER_NAME]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_SAVE_USER_NAME, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                let user_json = getters["GET_USER"];
                user_json.username = credentials.globalParams.fname + " " + credentials.globalParams.mname + " " + credentials.globalParams.lname;
                user_json.profile.firstname = credentials.globalParams.fname;
                user_json.profile.middlename = credentials.globalParams.mname;
                user_json.profile.lastname = credentials.globalParams.lname;
                user_json.mobile_no = credentials.globalParams.mobile_no;
                commit(SET_STATE, user_json);

                var user = localStorage.getItem("user");
                user = atob(user);
                user = JSON.parse(user);
                user.username = credentials.globalParams.fname + " " + credentials.globalParams.mname + " " + credentials.globalParams.lname;
                user.profile.firstname = credentials.globalParams.fname;
                user.profile.middlename = credentials.globalParams.mname;
                user.profile.lastname = credentials.globalParams.lname;
                user.mobile_no = credentials.globalParams.mobile_no;
                localStorage.setItem("user", btoa(JSON.stringify(user)));

                credentials.localParams.parameter.mobileShowvar = false;
                // COMMON._messageDisplayFunction(credentials.localParams.parameter,'suceessMsz9','success')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [RUN_DELETE_DOC]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_DELETE_DOC, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.getData != null) {
                    credentials.localParams.parameter.documentJsonData = {};
                    credentials.localParams.parameter.documentsByName[credentials.localParams.getData].data = [];
                    credentials.localParams.parameter.stepInfo();
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [RUN_SKIP_DOCUMENT_UPLOAD]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_SKIP_DOCUMENT_UPLOAD, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                let user_json = getters["GET_USER"];
                user_json.step = 5;
                commit(SET_STATE, user_json);

                var user = localStorage.getItem("user");
                user = atob(user);
                user = JSON.parse(user);
                user.step = 5;
                localStorage.setItem("user", btoa(JSON.stringify(user)));
                credentials.localParams.parameter.$router.replace("/create-live-account");

                if (parseInt(result.res_data.risk_status) == 1) {
                    credentials.localParams.parameter.iframeVar = "";
                    credentials.localParams.parameter.riskDiv = true;
                }

                /*else if(parseInt(result.res_data.risk_status) == 2){

                    credentials.localParams.parameter.$router.replace('/pending-verification')
                }*/
                COMMON._messageDisplayFunction(credentials.localParams.parameter, "suceessMsz8", "success");
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_msg, "error");
            }
        });
    },
    [RUN_GET_SUM_SUB_RESPONSE]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_SUM_SUB_RESPONSE, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.subSubResp(result.res_data);
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    [RUN_RESOLVE_DOC_ISSUE]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_RESOLVE_DOC_ISSUE, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.ipv_div = "";
                credentials.localParams.parameter.ticketDetail();
                // if(credentials.globalParams.overallStatus == 1){
                //  credentials.localParams.parameter.ipv_div = ''
                // }else{
                //  credentials.localParams.parameter.ipv_div = '1'
                // }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
    //================================get question-answer============================
    [RUN_GET_QUESTION_ANSWER]({ commit, state, dispatch, getters }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_QUESTION_ANSWER, credentials, { Authorization: "Bearer " + getters[GET_TOKEN] }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.ques_ans_list = result.res_data;
                /*let user_json = getters['GET_USER']
                if(user_json.step < 3){
                    credentials.localParams.parameter.ques_ans_array = Array(result.res_data.length).fill()
                    console.log(credentials.localParams.parameter.ques_ans_array)
                }
                //get sequence
                const questiondata = result.res_data
                let ques_ans = Object.keys(result.res_data)
                for (var i = ques_ans.length - 1; i >= 0; i--) {
                    if (questiondata[ques_ans[i]] && ques_ans[i]) {
                        credentials.localParams.parameter.question_answer_key_array[questiondata[ques_ans[i]].sequence] = ques_ans[i]
                    }
                }*/
                credentials.localParams.parameter.question_answer_key_array = result.res_data;
                let user_json = getters["GET_USER"];
                if (user_json.step < 2) {
                    for (let key in result.res_data) {
                        credentials.localParams.parameter.ques_ans_array[parseInt(key)] = "";
                    }
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
            }
        });
    },
};



// WEBPACK FOOTER //
// ./src/store/actions.js